import { render, staticRenderFns } from "./AppMessageInputBar.vue?vue&type=template&id=111553f2&scoped=true&"
import script from "./AppMessageInputBar.vue?vue&type=script&lang=js&"
export * from "./AppMessageInputBar.vue?vue&type=script&lang=js&"
import style0 from "./AppMessageInputBar.vue?vue&type=style&index=0&id=111553f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111553f2",
  null
  
)

export default component.exports